<template>
  <div class="protol protol__active">
    <div class="head">
      <div class="head__fixed">
        <div class="head__fixed__box">
          <div class="header__fixed__left"><a href="javascript:history.go(-1)" class="back"></a></div>
          <div class="header__fixed__center">
            <h1>斐燃会员使用细则</h1>
          </div>
          <div class="header__fixed__right"></div>
        </div>
      </div>
    </div>
      <div class="protol__box">
          <div class="protol__cont">
              <viperUseRules />
          </div>
      </div>
  </div>
</template>

<script>
  import viperUseRules from '../subgroup/viperUseRules.vue'
  export default {
    components:{
      'viperUseRules':viperUseRules
    },
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;
  .protol{
  	transition:all 0.5s;
  	display:none;
  	opacity:0;
  	position:fixed;
  	left:0;
  	top:0;
  	z-index:99;
  	width:100%;
  	height:100%;
  	background:#fff;
  	.protol__box{
  		width:100%;
  		height:100%;
  		display:flex;
  		flex-direction: column;
      padding-bottom: 120*@vm_base;
  	}
  	.protol__head{
  		width:100%;
  		height:88*@vm_base;
  		line-height:88*@vm_base;
  		border-bottom:1px solid #EAEAEA;
  		.back{
  			float:left;
  			width:88*@vm_base;
  			height:88*@vm_base;
  			background:url(../../assets/images/base/icon_close.png) center center no-repeat;
  			background-size:34*@vm_base auto;
  		}
  		.tit{
  			font-size:34*@vm_base;
  			font-weight:600;
  			color:rgba(51,51,51,1);
  			text-align:center;
  			overflow:hidden;
  		}
  	}
  	.protol__cont{
  		flex:1;
  		padding:30*@vm_base;
  		overflow:auto;
  		font-size:26*@vm_base;
  		font-weight:400;
  		color:rgba(102,102,102,1);
  		line-height:46*@vm_base;
  		h1{
  			font-size:40*@vm_base;
  			font-weight:500;
  			color:rgba(51,51,51,1);
  			line-height:48*@vm_base;
  		}
  		h3{
  			margin-top:20*@vm_base;
  			margin-bottom:15*@vm_base;
  			font-size:30*@vm_base;
  			font-weight:500;
  			color:rgba(51,51,51,1);
  			line-height:52*@vm_base;
  		}
  	}
  }
  .protol__active{
  	display:block;
  	opacity:1
  }
</style>



// WEBPACK FOOTER //
// src/components/protocol/useRules.vue